const addCarouselGradient = () => {
  const carousel = document.querySelector('#related-items-carousel');
  if (carousel) {
    const gradientOverlay = document.createElement('div');
    gradientOverlay.classList.add('gradient-overlay');
    carousel.appendChild(gradientOverlay);
  }

};



module.exports = { addCarouselGradient };



// WEBPACK FOOTER //
// ./scriptPartials/addCarouselGradient.js